<template>
    <v-dialog v-model="visible" width="600px" style="max-height: 100vh;" @click:outside="$emit('close')">
        <ModalContentTemplate
            :loading="loading"
            title="Buy A Car For Loved Ones Back Home With An Autoloan"
            videoSrc="/autoloans.mp4"
            @close="$emit('close')"
            @submit="onSubmit"
        />
    </v-dialog>
</template>

<script>
import ModalContentTemplate from './modal-content-template.vue';

export default {
    props: {
        visible: Boolean,
    },
    components: {
        ModalContentTemplate,
    },
    data() {
        return {
            loading: false,
        };
    },
    methods: {
        onSubmit(payload) {
            this.loading = true;
            this.addToWaitlist({
                  ...payload,
                  type: 'autoloan',
                })
                .then(() => {
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
    },
}
</script>
